import { render, staticRenderFns } from "./applyItem.vue?vue&type=template&id=3615b29f&scoped=true&"
import script from "./applyItem.vue?vue&type=script&lang=js&"
export * from "./applyItem.vue?vue&type=script&lang=js&"
import style0 from "./applyItem.vue?vue&type=style&index=0&id=3615b29f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3615b29f",
  null
  
)

export default component.exports